import {
  REQUEST_CATEGORIES,
  RECEIVE_CATEGORIES
} from '../actions/CategoriesActions';

const PropsInitialState = {
  items: []
};

function posts(
  state = {
    isFetching: false,
    didInvalidate: false,
    items: []
  },
  action
) {
  switch (action.type) {
    case REQUEST_CATEGORIES: {
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      });
    }
    case RECEIVE_CATEGORIES: {
      return Object.assign({}, state, {
        isFetching: false,
        items: action.items,
        lastUpdated: action.receivedAt
      });
    }
    default:
      return state;
  }
}

function CategoriesReducer(state = PropsInitialState, action) {
  switch (action.type) {
    case REQUEST_CATEGORIES:
    case RECEIVE_CATEGORIES: {
      return Object.assign({}, state, posts(state, action));
    }
    default: {
      return state;
    }
  }
}

export {
  CategoriesReducer
};


// WEBPACK FOOTER //
// ./src/reducers/CategoriesReducer.js